export default {
  DELETE: 'DELETE',
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE'
};